export const NAME = 'Zaloha';

export const POLOZKY = 'Polozky';

export const enum PolozkaStatus {
	unmodified = 0,
	inserted = 1,
	modified = 2,
	deleted = 3
}
